<div class="assortment-banner__wrapper">
  <a [href]="getBannerUrl()" target="_self">
    <div class="assortment-banner__image">
      <img [alt]="getTitle()" [src]="getImageSrc()" />
    </div>

    <div class="assortment-banner__content">
      <div
        [innerHTML]="getContentHeader()"
        [ngStyle]="getContentHeaderStyle()"
      ></div>
      <div
        [innerHTML]="getContent()"
        [ngStyle]="getBannerContentStyle()"
        class="hidden-mobile"
      ></div>

      @if (banner.hasButton) {
        <div>
          <a
            [href]="getBannerUrl()"
            [ngStyle]="getButtonContentStyle()"
            class="button"
            target="_self"
            >
            {{ banner.buttonText }}
          </a>
        </div>
      }
    </div>
  </a>
</div>
